import { render, staticRenderFns } from "./PromoDetail.vue?vue&type=template&id=3cf64c15&"
import script from "./PromoDetail.vue?vue&type=script&lang=js&"
export * from "./PromoDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports